import { RequiredCoding } from "./types";

export const sampleTypes: RequiredCoding[] = [
  {
    system: "http://snomed.info/sct",
    code: "258566005",
    display: "Deoxyribonucleic acid specimen",
  },
  {
    system: "http://snomed.info/sct",
    code: "440500007",
    display: "Dried blood spot specimen",
  },
  {
    system: "http://snomed.info/sct",
    code: "119342007",
    display: "Saliva specimen",
  },
  {
    system: "http://snomed.info/sct",
    code: "119376003",
    display: "Tissue specimen",
  },
  {
    system: "http://snomed.info/sct",
    code: "122555007",
    display: "Venous blood specimen",
  },
];
